import { createSelector } from 'reselect'

const calendarioReducerSelector = state => state.turneroReducer.getIn(["data"]).toJS()
export const calendarioSelector = createSelector(
    calendarioReducerSelector, (dataField) => {    
    return dataField.calendario
  }
)